<template>
    <div class="qyz">
        <div :class="['bigMapBox', { 'isM': !isPC }]">
            <div class="bg" :style="styleObj" @mousedown="move" @touchstart="moveM" ref="carouselContent" id="bg">
                <img src="../../assets/yzh_image/bg.png" alt="" @load="hideLoading = false" style="height: 100%;">

                <div class="dian" v-for="(dian, index) in dataList" :key="index"
                    :style="'top:' + (dian.top) / 4754 * 100 + '%;position:absolute;left:' + (dian.left) / 15681 * 100 + '%'">
                    <imgCard :item="dian.img" :divisor="7" :isYZH="true" @showDetail="showDetail"></imgCard>
                </div>
            </div>
        </div>

        <i class="btu el-icon-d-arrow-left" @click="moveClick('right')"></i>
        <i class="btu el-icon-d-arrow-right" @click="moveClick('left')"></i>

        <div class="dialog-mask" v-if="showDetailPage">
            <img :class="['closeMask', { 'isM': !isPC }]" src="../../assets/close_b.svg" alt=""
                @click.stop="closeDetail">
            <div class="dialog-mask-content">
                <yzhDetail :id="activeBoothNo" @closeDetail="closeDetail"></yzhDetail>
            </div>
        </div>
    </div>
</template>

<script>
import imgCard from './imgCard'
import yzhDetail from './yzhDetail.vue'
export default {
    components: { imgCard, yzhDetail },
    name: 'yzh',
    data() {
        return {
            styleObj: {
                position: "absolute",
                top: 0,
                left: 0,
                // left: "50%",
                // top: "50%",
                // transform: "translate(-50%,-50%)",
                height: "100%",
                whiteSpace: "nowrap",
                display: "inline-block",
                cursor: 'grab',
                overflow: 'auto',
                transformOrigin: '50% 50%',
                border: 'none',
                fontSize: '0'
                // transition:'all .3s'
            },
            dataList: [
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H05_470.png', top: 2460, left: 3900 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H07_464.png', top: 2460, left: 4500 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H09_460.png', top: 2460, left: 5160 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H11_470.png', top: 2460, left: 5880 },

                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H06_480.png', top: 2900, left: 4230 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H08_470.png', top: 2900, left: 4800 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H10_464.png', top: 2900, left: 5500 },

                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H02_485.png', top: 2084, left: 10760 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H01_480.png', top: 2080, left: 11300 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H03_509.png', top: 1960, left: 11770 },
                { img: 'https://cdnzyzs.secsa.cn/qingbohuizs/2024/yzh_image/H04_452.png', top: 1680, left: 12240 }

                // { img: require('../../assets/yzh_image/H05_470.png'), top: 2460, left: 3900 },
                // { img: require('../../assets/yzh_image/H07_464.png'), top: 2460, left: 4500 },
                // { img: require('../../assets/yzh_image/H09_460.png'), top: 2460, left: 5160 },
                // { img: require('../../assets/yzh_image/H11_470.png'), top: 2460, left: 5880 },

                // { img: require('../../assets/yzh_image/H06_480.png'), top: 2900, left: 4230 },
                // { img: require('../../assets/yzh_image/H08_470.png'), top: 2900, left: 4800 },
                // { img: require('../../assets/yzh_image/H10_464.png'), top: 2900, left: 5500 },

                // { img: require('../../assets/yzh_image/H02_485.png'), top: 2084, left: 10760 },
                // { img: require('../../assets/yzh_image/H01_480.png'), top: 2080, left: 11300 },
                // { img: require('../../assets/yzh_image/H03_509.png'), top: 1960, left: 11770 },
                // { img: require('../../assets/yzh_image/H04_452.png'), top: 1680, left: 12240 }
            ],
            showDetailPage: false,
            activeBoothNo: ''
        };
    },
    methods: {
        moveClick(side) {
            // 获取元素
            var img = document.querySelector(".bg");
            img.style.transition = 'all .5s';
            var x = img.offsetLeft;
            var imgWidth = img.offsetWidth;
            var winWidth = window.innerWidth || window.visualViewport.width;
            var ram = imgWidth - winWidth;
            let left = x - winWidth + 300;
            if (side == 'right') {
                left = x + winWidth - 300;
            }
            left = left > 0 ? 0 : Math.abs(left) < ram ? left : -ram;
            img.style.left = left + "px";
            setTimeout(() => {
                img.style.transition = '';
            }, 500)
        },
        closeDetail() {
            this.showDetailPage = false;
            this.$nextTick(() => {
                this.activeBoothNo = '';
            })
        },
        showDetail(item) {
            let paths = item.split('/');
            let boothNo = paths[paths.length - 1].split('_')[0];
            this.activeBoothNo = boothNo;
            this.showDetailPage = true;
        },
        // 拖动图片
        move(e) {
            e.preventDefault();
            // 获取元素
            var left = document.querySelector(".bigMapBox");
            var img = document.querySelector(".bg");
            var x = e.pageX - img.offsetLeft;
            // var y = e.pageY - img.offsetTop;
            var imgWidth = img.offsetWidth;
            var winWidth = window.innerWidth || window.visualViewport.width;
            var ram = imgWidth - winWidth;
            // 添加鼠标移动事件
            left.addEventListener("mousemove", move);

            function move(e) {
                let left = e.pageX - x;
                // let top = e.pageY - y;
                left = left > 0 ? 0 : Math.abs(left) < ram ? left : -ram;
                // top = top > 0 ? 0 : top;

                img.style.left = left + "px";
                // img.style.top = top + "px";
            }
            // 添加鼠标抬起事件，鼠标抬起，将事件移除
            img.addEventListener("mouseup", function () {
                left.removeEventListener("mousemove", move);
            });
            // 鼠标离开父级元素，把事件移除
            left.addEventListener("mouseout", function () {
                left.removeEventListener("mousemove", move);
            });
        },
        // 拖动图片
        moveM(e) {
            // console.log(e)
            e.preventDefault();
            // 获取元素
            var left = document.querySelector(".bigMapBox");
            var img = document.querySelector(".bg");
            var x = e.pageX - img.offsetLeft;
            var y = e.pageY - img.offsetTop;
            // 添加鼠标移动事件
            left.addEventListener("touchmove", move);
            function move(e) {
                img.style.left = e.pageX - x + "px";
                img.style.top = e.pageY - y + "px";
            }
            // 添加鼠标抬起事件，鼠标抬起，将事件移除
            img.addEventListener("touchend", function () {
                left.removeEventListener("touchmove", move);
            });
            // 鼠标离开父级元素，把事件移除
            left.addEventListener("touchend", function () {
                left.removeEventListener("touchmove", move);
            });
        },
    }
};
</script>

<style scoped>
.qyz {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background-color: #c4c8d3;
}

.bigMapBox {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    text-align: center;
    border: none
}


.btu {
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 1000;
    font-size: 6rem;
    color: #333;
    opacity: 0.5;
    cursor: pointer;
    animation: flash 3s infinite ease-in-out;
}

.btu:hover {
    opacity: 1;
    animation: none;
}


@keyframes flash {

    0%,
    100% {
        opacity: 1;
    }

    75% {
        opacity: 1;
    }

    25% {
        opacity: 1;
    }

    50% {
        opacity: 0.3;
    }
}


.el-icon-d-arrow-left {
    left: 2rem;
}

.el-icon-d-arrow-right {
    right: 2rem;
}

.isM {
    width: 2190px;
}

.dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99999;
}

.closeMask {
    position: fixed;
    top: -20px;
    right: 0;
    z-index: 1000;
    font-size: 20px;
    opacity: 0.8;
    cursor: pointer;
    transform: all 0.5s ease-in-out;
}

.closeMask:hover {
    opacity: 1;
}

.closeMask.isM {
    width: 10rem;
    top: 0;
}


.dialog-mask-content {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #fff;
    overflow-y: auto;
}
</style>